import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggleShowBtn', 'extraParagraph']
  static values = {
    showDetails: { type: Boolean, default: false }
  }

  toggleShowDetails(event) {
    event.preventDefault()
    this.showDetailsValue = !this.showDetailsValue
  }

  showDetailsValueChanged() {
    if (this.showDetailsValue) {
      this.toggleShowBtnTarget.innerHTML = 'Show Less'
      this.extraParagraphTarget.classList.remove('hidden')
    } else {
      this.toggleShowBtnTarget.innerHTML = 'Show More'
      this.extraParagraphTarget.classList.add('hidden')
    }
  }
}